import { useQuery } from '@tanstack/react-query';

// helper
import { BaseError } from './../../helpers/BaseError';

import { DatasetModel } from '../../models/dataset.model';

// services
import API from '../../services/api';

import queryKeys from './__queryKeys';

const getDatasets = async (datasetId?: number) => {
    const { data } = await API.fetchDatasetById(datasetId);
    return data as DatasetModel;
};

export default function useDatasetsQuery(datasetId?: number) {
    return useQuery<DatasetModel, BaseError>({
        queryKey: queryKeys.dataset(datasetId),
        queryFn: () => getDatasets(datasetId),
        enabled: !!datasetId,
    });
}
